import "core-js/modules/es6.number.constructor";
export default {
  name: "slideUp",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    time: {
      type: Number,
      default: 200
    }
  },
  computed: {
    isSlided: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit("input", val);
      }
    },
    slideStyle: function slideStyle() {
      return {
        "-webkit-transition-duration": this.time + "ms",
        "-o-transition-duration": this.time + "ms",
        "transition-duration": this.time + "ms"
      };
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.isSlided = false;
    }
  },
  inheritAttrs: false
};